module.exports = __webpack_public_path__ + "img/implantacao.5cd4ed97.jpg";